import App from '@/models/App'
import Organization from '@/models/Organization'
import Restrict from '@/models/Restrict'

export default class Profile extends App {
    static get entity() {
        return 'profiles'
    }
    static one() {
        return this.query().withAllRecursive().first()
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            maritimeId: this.attr(''),
            firstName: this.attr(''),
            middleName: this.attr(''),
            lastName: this.attr(''),
            employeeNo: this.attr(''),
            job: this.attr(''),
            email: this.attr(''),
            token: this.attr(''),
            profileImage: this.attr(''),
            chatRoom: this.attr(''),
            organization: this.belongsTo(Organization, 'organizationId'),
            restrict: this.hasOne(Restrict, 'userId'),
        }
    }
    get anyMiddleName() {
        return this.middleName ?? ''
    }
    get fullName() {
        return `${this.lastName} ${this.anyMiddleName} ${this.firstName}`
    }
    static apiConfig = {
        actions: {
            signup(params) {
                return this.get(`/auth/signup`, {
                    params: {
                        companyName: params.companyName,
                        firstName: params.firstName,
                        middleName: params.middleName,
                        lastName: params.lastName,
                        email: params.email,
                        job: params.job,
                    },
                    headers: {
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'profile',
                    baseURL: App.apiURL(),
                    persistOptions: {
                        insertOrUpdate: ['organization', 'restrict'],
                    },
                })
            },
            business(params) {
                return this.get(`/auth/business`, {
                    params: {
                        companyName: params.companyName,
                        firstName: params.firstName,
                        middleName: params.middleName,
                        lastName: params.lastName,
                        email: params.email,
                        job: params.job,
                    },
                    headers: {
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'profile',
                    baseURL: App.apiURL(),
                    persistOptions: {
                        insertOrUpdate: ['organization', 'restrict'],
                    },
                })
            },
            signin(params) {
                return this.get(`/auth/signin`, {
                    params: {
                        email: params.email,
                        password: params.password,
                    },
                    headers: {
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'profile',
                    baseURL: App.apiURL(),
                    persistOptions: {
                        insertOrUpdate: ['organization', 'restrict'],
                    },
                })
            },
            verify() {
                return this.get(`/auth/verify`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'profile',
                    baseURL: App.apiURL(),
                    persistOptions: {
                        insertOrUpdate: ['organization', 'restrict'],
                    },
                })
            },
            upload(userId, params) {
                return this.patch(
                    `/users/${userId}/upload`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.overallURL(),
                    }
                )
            },
        },
    }
}
